export const EMAIL_FIELD_VALIDATION_REGEX =
  /^\s*([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})\s*$/i;
